// Cabinet kit presets exported from MG-WNKcabi-Editor.
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-WNK32cabi"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WWSH-wBox-Cabinets_7178691f-fbc4-4cde-8535-2269b4da749b.png?v=1778703561&width=400",
          "product_url": "/products/cabinetkit_white-wash_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_white-wash_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-wBox-Cabinets_e76ffe68-300e-465b-bf98-9551e8ca8b1c.png?v=1778700179&width=400",
          "product_url": "/products/cabinetkit_white-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_white-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-wBox-Cabinets_8258a0fc-1908-4e84-af34-a3414b3f893f.png?v=1778703901&width=400",
          "product_url": "/products/cabinetkit_french-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_french-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-MWAL-Swatch-Rustic-Small.jpg?v=1777021282",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-_-wBox-Cabinets.png?v=1785507671&width=400",
          "product_url": "/products/cabinetkit_modern-walnut_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_modern-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-wBox-Cabinets_7f3f1f31-329c-4cee-87e9-3a831ac62f5c.png?v=1779123655&width=400",
          "product_url": "/products/cabinetkit_dark-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_dark-oak_s",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-wBox-Cabinets_81f3e7c5-a38e-4d08-822c-98c5aa581fe4.png?v=1778699773&width=400",
          "product_url": "/products/cabinetkit_sun-bleached_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_sun-bleached_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-wBox-Cabinets_0c63a8bd-b65e-471d-bc50-17b00a346080.png?v=1778700896&width=400",
          "product_url": "/products/cabinetkit_pickled-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_pickled-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN-wBox-Cabinets_4454a485-d7a1-45d3-a240-77b7c2d2de63.png?v=1778701310&width=400",
          "product_url": "/products/cabinetkit_barn-wood_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_barn-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-wBox-Cabinets_fa53119a-518b-420b-b544-0f376626f04c.png?v=1778703019&width=400",
          "product_url": "/products/cabinetkit_black-walnut_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_black-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WETH-wBox-Cabinets_0f45c22f-7334-4282-8a71-500bc34ba91d.png?v=1779118483&width=400",
          "product_url": "/products/cabinetkit_weathered-wood_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_weathered-wood_s",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW-wBox-Cabinets_9fff2d91-ea35-489f-b1b5-2b030dfbdbd5.png?v=1778705432&width=400",
          "product_url": "/products/cabinetkit_drift-wood_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_drift-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CEDR-wBox-Cabinets_46f04c17-9599-4481-b574-1682759c65fd.png?v=1778771513&width=400",
          "product_url": "/products/cabinetkit_cedar_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_cedar_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHRY-wBox-Cabinets_89e53a63-bf7d-42c7-b688-9a46f2f22d08.png?v=1778769651&width=400",
          "product_url": "/products/cabinetkit_vintage-cherry_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_vintage-cherry_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA-wBox-Cabinets_fb747f24-b4dc-44b4-ba80-87cdfc488862.png?v=1778770569&width=400",
          "product_url": "/products/cabinetkit_java_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_java_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-wBox-Cabinets_3739501c-ca9a-496a-92f7-ce1d4cd8e478.png?v=1778770996&width=400",
          "product_url": "/products/cabinetkit_red-mahogany_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_red-mahogany_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-OOAK-wBox-Cabinets_d97e80d6-26a2-483d-b25e-7345e4edfffa.png?v=1778771961&width=400",
          "product_url": "/products/cabinetkit_old-oak_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_old-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch--WoodnStain_95636ac8-3a32-4941-a85e-d8dfe355c4f5_800x800.jpg?v=1774460111",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-PECA-wBox-Cabinets_7ccd2ef1-2505-43c8-9c1b-1c9b9ac596e4_800x800.png?v=1778772305",
          "product_url": "/products/cabinetkit_pecan_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_pecan_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHAR-wBox-Cabinets_1df9643f-c086-4efe-8dda-aa39122c7906.png?v=1778769100&width=400",
          "product_url": "/products/cabinetkit_charcoal_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_charcoal_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CBLK-wBox-Cabinets_9ab9659d-a04e-4ea3-8f52-f5989c127b75.png?v=1778770160&width=400",
          "product_url": "/products/cabinetkit_classic-black_s",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_classic-black_s",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK64cabi"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK32cabi"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-WWSH-wBox-Cabinets_5e2a5308-2ae2-4235-8af9-4e046620d68f.png?v=1778703667&width=400",
          "product_url": "/products/cabinetkit_white-wash_m",
          "cta": {
            "href": "/products/cabinetkit_white-wash_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-WOAK-wBox-Cabinets_4a8bd42e-58f2-4e03-a78f-d261812f43a6.png?v=1778700310&width=400",
          "product_url": "/products/cabinetkit_white-oak_m",
          "cta": {
            "href": "/products/cabinetkit_white-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-FOAK-wBox-Cabinets_4d843391-41e9-407c-a9cd-e737cd08c5fe.png?v=1778704168&width=400",
          "product_url": "/products/cabinetkit_french-oak_m",
          "cta": {
            "href": "/products/cabinetkit_french-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-MWAL-Swatch-Rustic-Small.jpg?v=1777021282",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-MWAL-_-wBox-Cabinets.png?v=1785507858&width=400",
          "product_url": "/products/cabinetkit_modern-walnut_m",
          "cta": {
            "href": "/products/cabinetkit_modern-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-DOAK-wBox-Cabinets_872441f1-7d4f-4a4a-9ede-d6c3ef71dc1d.png?v=1779123814&width=400",
          "product_url": "/products/cabinetkit_dark-oak_m",
          "cta": {
            "href": "/products/cabinetkit_dark-oak_m",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-SBCH-wBox-Cabinets_86b523f0-ca43-4e04-8a01-9e70728c883c.png?v=1778699888&width=400",
          "product_url": "/products/cabinetkit_sun-bleached_m",
          "cta": {
            "href": "/products/cabinetkit_sun-bleached_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-POAK-wBox-Cabinets_3b3e5c08-5162-4847-8b03-3f9e241bc321.png?v=1778700994&width=400",
          "product_url": "/products/cabinetkit_pickled-oak_m",
          "cta": {
            "href": "/products/cabinetkit_pickled-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-BARN-wBox-Cabinets_b9ed91e8-cf12-4836-bece-1810f8b39413.png?v=1778701425&width=400",
          "product_url": "/products/cabinetkit_barn-wood_m",
          "cta": {
            "href": "/products/cabinetkit_barn-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-BWAL-wBox-Cabinets_06ecbcbd-a43a-40d2-953d-fdc0bdde3b33.png?v=1778703132&width=400",
          "product_url": "/products/cabinetkit_black-walnut_m",
          "cta": {
            "href": "/products/cabinetkit_black-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-WETH-wBox-Cabinets_ee27bccf-dd05-48b4-aede-3bfc7cadf34e.png?v=1779118620&width=400",
          "product_url": "/products/cabinetkit_weathered-wood_m",
          "cta": {
            "href": "/products/cabinetkit_weathered-wood_m",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-DRIW-wBox-Cabinets_79b48ac4-bd5f-476d-bdd1-31e318c2e43e.png?v=1778705548&width=400",
          "product_url": "/products/cabinetkit_drift-wood_m",
          "cta": {
            "href": "/products/cabinetkit_drift-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CEDR-wBox-Cabinets_de2b3982-5163-4ac6-ab5c-d87f6af38365.png?v=1778771604&width=400",
          "product_url": "/products/cabinetkit_cedar_m",
          "cta": {
            "href": "/products/cabinetkit_cedar_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CHRY-wBox-Cabinets_2fa879d8-6a0f-452b-a527-f8c1a8fd22bf.png?v=1778769868&width=400",
          "product_url": "/products/cabinetkit_vintage-cherry_m",
          "cta": {
            "href": "/products/cabinetkit_vintage-cherry_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-JAVA-wBox-Cabinets_87645352-b0f7-4053-94c8-c9db4ff511d8.png?v=1778770704&width=400",
          "product_url": "/products/cabinetkit_java_m",
          "cta": {
            "href": "/products/cabinetkit_java_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-RMGY-wBox-Cabinets_9581dacb-9789-46d3-9971-2df5c4b2bdf0.png?v=1778771190&width=400",
          "product_url": "/products/cabinetkit_red-mahogany_m",
          "cta": {
            "href": "/products/cabinetkit_red-mahogany_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-OOAK-wBox-Cabinets_c4520460-ef77-4178-b00d-a2f1b83c89b4.png?v=1778772065&width=400",
          "product_url": "/products/cabinetkit_old-oak_m",
          "cta": {
            "href": "/products/cabinetkit_old-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch--WoodnStain_95636ac8-3a32-4941-a85e-d8dfe355c4f5_800x800.jpg?v=1774460111",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-PECA-wBox-Cabinets_da644ef3-19c3-4a68-b0c1-de83055e5ef7_800x800.png?v=1778772421",
          "product_url": "/products/cabinetkit_pecan_m",
          "cta": {
            "href": "/products/cabinetkit_pecan_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CHAR-wBox-Cabinets_d2ebbe99-a96d-479d-8cee-365cfd1a5907.png?v=1778769299&width=400",
          "product_url": "/products/cabinetkit_charcoal_m",
          "cta": {
            "href": "/products/cabinetkit_charcoal_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CBLK-wBox-Cabinets_5633f36e-24d1-4a93-a30c-d151524e0de8.png?v=1778770266&width=400",
          "product_url": "/products/cabinetkit_classic-black_m",
          "cta": {
            "href": "/products/cabinetkit_classic-black_m",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK128cabi"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK32cabi"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WWSH-wBox-Cabinets_cda2fcfa-c158-441e-9ef4-1331c9f20b67.png?v=1778703769&width=400",
          "product_url": "/products/cabinetkit_white-wash_l",
          "cta": {
            "href": "/products/cabinetkit_white-wash_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-wBox-Cabinets_2f2d2d83-e0f3-49ac-a595-4d16fdbfd057.png?v=1778700439&width=400",
          "product_url": "/products/cabinetkit_white-oak_l",
          "cta": {
            "href": "/products/cabinetkit_white-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-wBox-Cabinets_16068c2d-8fe0-4baa-8d17-62babdff097f.png?v=1778704274&width=400",
          "product_url": "/products/cabinetkit_french-oak_l",
          "cta": {
            "href": "/products/cabinetkit_french-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-MWAL-Swatch-Rustic-Small.jpg?v=1777021282",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-_-wBox-Cabinets.png?v=1785508015&width=400",
          "product_url": "/products/cabinetkit_modern-walnut_l",
          "cta": {
            "href": "/products/cabinetkit_modern-walnut_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-wBox-Cabinets_6fbaf874-887e-4f46-9037-041fc49995f3.png?v=1779124118&width=400",
          "product_url": "/products/cabinetkit_dark-oak_l",
          "cta": {
            "href": "/products/cabinetkit_dark-oak_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-wBox-Cabinets_522e6537-061f-41fc-aad8-35320f4405a1.png?v=1778700027&width=400",
          "product_url": "/products/cabinetkit_sun-bleached_l",
          "cta": {
            "href": "/products/cabinetkit_sun-bleached_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-wBox-Cabinets_7b73ab11-63d9-4e40-b9ce-21b33940f904.png?v=1778701099&width=400",
          "product_url": "/products/cabinetkit_pickled-oak_l",
          "cta": {
            "href": "/products/cabinetkit_pickled-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-wBox-Cabinets_c0a4c0d1-d818-48f4-8bfc-fb1505e4404a.png?v=1778701539&width=400",
          "product_url": "/products/cabinetkit_barn-wood_l",
          "cta": {
            "href": "/products/cabinetkit_barn-wood_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-wBox-Cabinets_354c9def-2744-47f2-8e86-2044c8e3e433.png?v=1778703273&width=400",
          "product_url": "/products/cabinetkit_black-walnut_l",
          "cta": {
            "href": "/products/cabinetkit_black-walnut_l",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WETH-wBox-Cabinets_3a7d3fa8-eb40-437d-839d-565b2bb9ef55.png?v=1779118745&width=400",
          "product_url": "/products/cabinetkit_weathered-wood_l",
          "cta": {
            "href": "/products/cabinetkit_weathered-wood_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DRIW-wBox-Cabinets_0120f025-3942-4d50-bf27-0de973bf9da2.png?v=1778705735&width=400",
          "product_url": "/products/cabinetkit_drift-wood_l",
          "cta": {
            "href": "/products/cabinetkit_drift-wood_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CEDR-wBox-Cabinets_54f4b3af-505c-4ce0-9135-c9b95de560f1.png?v=1778771754&width=400",
          "product_url": "/products/cabinetkit_cedar_l",
          "cta": {
            "href": "/products/cabinetkit_cedar_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY-wBox-Cabinets_1dde9149-e685-406e-b7a4-964d8ab99a9c.png?v=1778769997&width=400",
          "product_url": "/products/cabinetkit_vintage-cherry_l",
          "cta": {
            "href": "/products/cabinetkit_vintage-cherry_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-JAVA-wBox-Cabinets_0196cd1a-6603-446d-a61c-c5d3715807b8.png?v=1778770823&width=400",
          "product_url": "/products/cabinetkit_java_l",
          "cta": {
            "href": "/products/cabinetkit_java_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-RMGY-wBox-Cabinets_544cf0c2-e3c5-458a-b198-05afc7d48dee.png?v=1778771325&width=400",
          "product_url": "/products/cabinetkit_red-mahogany_l",
          "cta": {
            "href": "/products/cabinetkit_red-mahogany_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-OOAK-wBox-Cabinets_a2c389e1-1ba3-48d4-9632-b8ee314f3a9d.png?v=1778772165&width=400",
          "product_url": "/products/cabinetkit_old-oak_l",
          "cta": {
            "href": "/products/cabinetkit_old-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch--WoodnStain_95636ac8-3a32-4941-a85e-d8dfe355c4f5_800x800.jpg?v=1774460111",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-PECA-wBox-Cabinets_9105e489-933f-4964-9b09-9162e41a506f_800x800.png?v=1778772519",
          "product_url": "/products/cabinetkit_pecan_l",
          "cta": {
            "href": "/products/cabinetkit_pecan_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHAR-wBox-Cabinets_0b262349-6a5d-49ff-9b17-e74780ea792c.png?v=1778769429&width=400",
          "product_url": "/products/cabinetkit_charcoal_l",
          "cta": {
            "href": "/products/cabinetkit_charcoal_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CBLK-wBox-Cabinets_a7c09a8d-a74b-4fab-84fa-88faf635f454.png?v=1778770405&width=400",
          "product_url": "/products/cabinetkit_classic-black_l",
          "cta": {
            "href": "/products/cabinetkit_classic-black_l",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-SBCH"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-SBCH-wBox-Cabinets_81f3e7c5-a38e-4d08-822c-98c5aa581fe4.png?v=1778699773&width=400",
          "product_url": "/products/cabinetkit_sun-bleached_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_sun-bleached_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-SBCH-wBox-Cabinets_86b523f0-ca43-4e04-8a01-9e70728c883c.png?v=1778699888&width=400",
          "product_url": "/products/cabinetkit_sun-bleached_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_sun-bleached_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-SBCH-wBox-Cabinets_522e6537-061f-41fc-aad8-35320f4405a1.png?v=1778700027&width=400",
          "product_url": "/products/cabinetkit_sun-bleached_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_sun-bleached_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-WWSH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WWSH-wBox-Cabinets_7178691f-fbc4-4cde-8535-2269b4da749b.png?v=1778703561&width=400",
          "product_url": "/products/cabinetkit_white-wash_s",
          "cta": {
            "href": "/products/cabinetkit_white-wash_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-WWSH-wBox-Cabinets_5e2a5308-2ae2-4235-8af9-4e046620d68f.png?v=1778703667&width=400",
          "product_url": "/products/cabinetkit_white-wash_m",
          "cta": {
            "href": "/products/cabinetkit_white-wash_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WWSH-wBox-Cabinets_cda2fcfa-c158-441e-9ef4-1331c9f20b67.png?v=1778703769&width=400",
          "product_url": "/products/cabinetkit_white-wash_l",
          "cta": {
            "href": "/products/cabinetkit_white-wash_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-WOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WOAK-wBox-Cabinets_e76ffe68-300e-465b-bf98-9551e8ca8b1c.png?v=1778700179&width=400",
          "product_url": "/products/cabinetkit_white-oak_s",
          "cta": {
            "href": "/products/cabinetkit_white-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-WOAK-wBox-Cabinets_4a8bd42e-58f2-4e03-a78f-d261812f43a6.png?v=1778700310&width=400",
          "product_url": "/products/cabinetkit_white-oak_m",
          "cta": {
            "href": "/products/cabinetkit_white-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WOAK-wBox-Cabinets_2f2d2d83-e0f3-49ac-a595-4d16fdbfd057.png?v=1778700439&width=400",
          "product_url": "/products/cabinetkit_white-oak_l",
          "cta": {
            "href": "/products/cabinetkit_white-oak_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-POAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-POAK-wBox-Cabinets_0c63a8bd-b65e-471d-bc50-17b00a346080.png?v=1778700896&width=400",
          "product_url": "/products/cabinetkit_pickled-oak_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_pickled-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-POAK-wBox-Cabinets_3b3e5c08-5162-4847-8b03-3f9e241bc321.png?v=1778700994&width=400",
          "product_url": "/products/cabinetkit_pickled-oak_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_pickled-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-POAK-wBox-Cabinets_7b73ab11-63d9-4e40-b9ce-21b33940f904.png?v=1778701099&width=400",
          "product_url": "/products/cabinetkit_pickled-oak_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_pickled-oak_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-BARN"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN-wBox-Cabinets_4454a485-d7a1-45d3-a240-77b7c2d2de63.png?v=1778701310&width=400",
          "product_url": "/products/cabinetkit_barn-wood_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_barn-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-BARN-wBox-Cabinets_b9ed91e8-cf12-4836-bece-1810f8b39413.png?v=1778701425&width=400",
          "product_url": "/products/cabinetkit_barn-wood_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_barn-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BARN-wBox-Cabinets_c0a4c0d1-d818-48f4-8bfc-fb1505e4404a.png?v=1778701539&width=400",
          "product_url": "/products/cabinetkit_barn-wood_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_barn-wood_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-DOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DOAK-wBox-Cabinets_7f3f1f31-329c-4cee-87e9-3a831ac62f5c.png?v=1779123655&width=400",
          "product_url": "/products/cabinetkit_dark-oak_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_dark-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-DOAK-wBox-Cabinets_872441f1-7d4f-4a4a-9ede-d6c3ef71dc1d.png?v=1779123814&width=400",
          "product_url": "/products/cabinetkit_dark-oak_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_dark-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DOAK-wBox-Cabinets_6fbaf874-887e-4f46-9037-041fc49995f3.png?v=1779124118&width=400",
          "product_url": "/products/cabinetkit_dark-oak_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_dark-oak_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-BWAL"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BWAL-wBox-Cabinets_fa53119a-518b-420b-b544-0f376626f04c.png?v=1778703019&width=400",
          "product_url": "/products/cabinetkit_black-walnut_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_black-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-BWAL-wBox-Cabinets_06ecbcbd-a43a-40d2-953d-fdc0bdde3b33.png?v=1778703132&width=400",
          "product_url": "/products/cabinetkit_black-walnut_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_black-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-BWAL-wBox-Cabinets_354c9def-2744-47f2-8e86-2044c8e3e433.png?v=1778703273&width=400",
          "product_url": "/products/cabinetkit_black-walnut_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_black-walnut_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-MWAL"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-MWAL-_-wBox-Cabinets.png?v=1785507671&width=400",
          "product_url": "/products/cabinetkit_modern-walnut_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_modern-walnut_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-MWAL-_-wBox-Cabinets.png?v=1785507858&width=400",
          "product_url": "/products/cabinetkit_modern-walnut_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_modern-walnut_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-MWAL-_-wBox-Cabinets.png?v=1785508015&width=400",
          "product_url": "/products/cabinetkit_modern-walnut_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_modern-walnut_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-FOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-FOAK-wBox-Cabinets_8258a0fc-1908-4e84-af34-a3414b3f893f.png?v=1778703901&width=400",
          "product_url": "/products/cabinetkit_french-oak_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_french-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-FOAK-wBox-Cabinets_4d843391-41e9-407c-a9cd-e737cd08c5fe.png?v=1778704168&width=400",
          "product_url": "/products/cabinetkit_french-oak_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_french-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-FOAK-wBox-Cabinets_16068c2d-8fe0-4baa-8d17-62babdff097f.png?v=1778704274&width=400",
          "product_url": "/products/cabinetkit_french-oak_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_french-oak_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-DRIW"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-DRIW-wBox-Cabinets_9fff2d91-ea35-489f-b1b5-2b030dfbdbd5.png?v=1778705432&width=400",
          "product_url": "/products/cabinetkit_drift-wood_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_drift-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-DRIW-wBox-Cabinets_79b48ac4-bd5f-476d-bdd1-31e318c2e43e.png?v=1778705548&width=400",
          "product_url": "/products/cabinetkit_drift-wood_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_drift-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DRIW-wBox-Cabinets_0120f025-3942-4d50-bf27-0de973bf9da2.png?v=1778705735&width=400",
          "product_url": "/products/cabinetkit_drift-wood_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_drift-wood_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-WETH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-WETH-wBox-Cabinets_0f45c22f-7334-4282-8a71-500bc34ba91d.png?v=1779118483&width=400",
          "product_url": "/products/cabinetkit_weathered-wood_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_weathered-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-WETH-wBox-Cabinets_ee27bccf-dd05-48b4-aede-3bfc7cadf34e.png?v=1779118620&width=400",
          "product_url": "/products/cabinetkit_weathered-wood_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_weathered-wood_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-WETH-wBox-Cabinets_3a7d3fa8-eb40-437d-839d-565b2bb9ef55.png?v=1779118745&width=400",
          "product_url": "/products/cabinetkit_weathered-wood_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_weathered-wood_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-CHAR"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHAR-wBox-Cabinets_1df9643f-c086-4efe-8dda-aa39122c7906.png?v=1778769100&width=400",
          "product_url": "/products/cabinetkit_charcoal_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_charcoal_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CHAR-wBox-Cabinets_d2ebbe99-a96d-479d-8cee-365cfd1a5907.png?v=1778769299&width=400",
          "product_url": "/products/cabinetkit_charcoal_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_charcoal_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHAR-wBox-Cabinets_0b262349-6a5d-49ff-9b17-e74780ea792c.png?v=1778769429&width=400",
          "product_url": "/products/cabinetkit_charcoal_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_charcoal_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-VCHY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CHRY-wBox-Cabinets_89e53a63-bf7d-42c7-b688-9a46f2f22d08.png?v=1778769651&width=400",
          "product_url": "/products/cabinetkit_vintage-cherry_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_vintage-cherry_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CHRY-wBox-Cabinets_2fa879d8-6a0f-452b-a527-f8c1a8fd22bf.png?v=1778769868&width=400",
          "product_url": "/products/cabinetkit_vintage-cherry_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_vintage-cherry_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CHRY-wBox-Cabinets_1dde9149-e685-406e-b7a4-964d8ab99a9c.png?v=1778769997&width=400",
          "product_url": "/products/cabinetkit_vintage-cherry_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_vintage-cherry_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-CBLK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CBLK-wBox-Cabinets_9ab9659d-a04e-4ea3-8f52-f5989c127b75.png?v=1778770160&width=400",
          "product_url": "/products/cabinetkit_classic-black_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_classic-black_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CBLK-wBox-Cabinets_5633f36e-24d1-4a93-a30c-d151524e0de8.png?v=1778770266&width=400",
          "product_url": "/products/cabinetkit_classic-black_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_classic-black_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CBLK-wBox-Cabinets_a7c09a8d-a74b-4fab-84fa-88faf635f454.png?v=1778770405&width=400",
          "product_url": "/products/cabinetkit_classic-black_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_classic-black_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-JAVA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-JAVA-wBox-Cabinets_fb747f24-b4dc-44b4-ba80-87cdfc488862.png?v=1778770569&width=400",
          "product_url": "/products/cabinetkit_java_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_java_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-JAVA-wBox-Cabinets_87645352-b0f7-4053-94c8-c9db4ff511d8.png?v=1778770704&width=400",
          "product_url": "/products/cabinetkit_java_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_java_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-JAVA-wBox-Cabinets_0196cd1a-6603-446d-a61c-c5d3715807b8.png?v=1778770823&width=400",
          "product_url": "/products/cabinetkit_java_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_java_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-RMGY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-RMGY-wBox-Cabinets_3739501c-ca9a-496a-92f7-ce1d4cd8e478.png?v=1778770996&width=400",
          "product_url": "/products/cabinetkit_red-mahogany_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_red-mahogany_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-RMGY-wBox-Cabinets_9581dacb-9789-46d3-9971-2df5c4b2bdf0.png?v=1778771190&width=400",
          "product_url": "/products/cabinetkit_red-mahogany_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_red-mahogany_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-RMGY-wBox-Cabinets_544cf0c2-e3c5-458a-b198-05afc7d48dee.png?v=1778771325&width=400",
          "product_url": "/products/cabinetkit_red-mahogany_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_red-mahogany_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-CEDR"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-CEDR-wBox-Cabinets_46f04c17-9599-4481-b574-1682759c65fd.png?v=1778771513&width=400",
          "product_url": "/products/cabinetkit_cedar_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_cedar_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-CEDR-wBox-Cabinets_de2b3982-5163-4ac6-ab5c-d87f6af38365.png?v=1778771604&width=400",
          "product_url": "/products/cabinetkit_cedar_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_cedar_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-CEDR-wBox-Cabinets_54f4b3af-505c-4ce0-9135-c9b95de560f1.png?v=1778771754&width=400",
          "product_url": "/products/cabinetkit_cedar_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_cedar_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-OOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-OOAK-wBox-Cabinets_d97e80d6-26a2-483d-b25e-7345e4edfffa.png?v=1778771961&width=400",
          "product_url": "/products/cabinetkit_old-oak_s",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_old-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-OOAK-wBox-Cabinets_c4520460-ef77-4178-b00d-a2f1b83c89b4.png?v=1778772065&width=400",
          "product_url": "/products/cabinetkit_old-oak_m",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_old-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-OOAK-wBox-Cabinets_a2c389e1-1ba3-48d4-9632-b8ee314f3a9d.png?v=1778772165&width=400",
          "product_url": "/products/cabinetkit_old-oak_l",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/cabinetkit_old-oak_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKcabi-PECA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-WNKcabi-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "12 Door Cabinet Kit",
          "alt": "12 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-PECA-wBox-Cabinets_7ccd2ef1-2505-43c8-9c1b-1c9b9ac596e4_800x800.png?v=1778772305",
          "product_url": "/products/cabinetkit_pecan_s",
          "cta": {
            "href": "/products/cabinetkit_pecan_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "24 Door Cabinet Kit",
          "alt": "24 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-PECA-wBox-Cabinets_da644ef3-19c3-4a68-b0c1-de83055e5ef7_800x800.png?v=1778772421",
          "product_url": "/products/cabinetkit_pecan_m",
          "cta": {
            "href": "/products/cabinetkit_pecan_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "48 Door Cabinet Kit",
          "alt": "48 Door Cabinet Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-PECA-wBox-Cabinets_9105e489-933f-4964-9b09-9162e41a506f_800x800.png?v=1778772519",
          "product_url": "/products/cabinetkit_pecan_l",
          "cta": {
            "href": "/products/cabinetkit_pecan_l",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p>12 Door Cabinet Kit — 100 square feet</p><p>24 Door Cabinet Kit — 200 square feet</p><p>48 Door Cabinet Kit — 400 square feet</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
